import { render, staticRenderFns } from "./rowDataPagination.vue?vue&type=template&id=1a6b0d5f&scoped=true"
import script from "./rowDataPagination.vue?vue&type=script&lang=js"
export * from "./rowDataPagination.vue?vue&type=script&lang=js"
import style0 from "./rowDataPagination.vue?vue&type=style&index=0&id=1a6b0d5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b0d5f",
  null
  
)

export default component.exports